var map = {
	"./alien.gif": 50430,
	"./bomb.gif": 65234,
	"./bowling.gif": 3246,
	"./cold_face.gif": 94203,
	"./cow_face.gif": 5515,
	"./cowboy_hat_face.gif": 12958,
	"./dog_face.gif": 99963,
	"./fire.gif": 9837,
	"./flying_saucer.gif": 62447,
	"./frog.gif": 91232,
	"./ghost.gif": 49152,
	"./hear_no_evil_monkey.gif": 45139,
	"./honeybee.gif": 74613,
	"./horse.gif": 384,
	"./kangaroo.gif": 13087,
	"./oncoming_police_car.gif": 94328,
	"./owl.gif": 63233,
	"./penguin.gif": 25996,
	"./person_juggling.gif": 51771,
	"./pig_face.gif": 72784,
	"./pile_of_poo.gif": 56853,
	"./popcorn.gif": 10038,
	"./rabbit_face.gif": 53636,
	"./robot.gif": 1474,
	"./rocket.gif": 47955,
	"./roller_coaster.gif": 35829,
	"./sloth.gif": 84604,
	"./smiling_face_with_horns.gif": 13929,
	"./smiling_face_with_sunglasses.gif": 63314,
	"./snowman.gif": 2036,
	"./soccer_ball.gif": 53683,
	"./spouting_whale.gif": 12866,
	"./unicorn.gif": 39966,
	"./volcano.gif": 89951,
	"./zombie.gif": 28827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58756;